import { intlLocale } from '@/i18n'
import type { Slot } from './types'

/** Monday … Sunday in the UI language (ISO 1–7). */
export function weekdayName(day: number, style: 'long' | 'short' = 'long'): string {
  // 2024-01-01 was a Monday.
  return new Intl.DateTimeFormat(intlLocale(), { weekday: style }).format(new Date(2024, 0, day))
}

export function formatDay(iso: string, withYear = false): string {
  return new Intl.DateTimeFormat(intlLocale(), {
    weekday: 'short',
    day: 'numeric',
    month: 'short',
    ...(withYear ? { year: 'numeric' } : {}),
  }).format(new Date(iso + 'T00:00:00'))
}

export function formatRange(from: string, to: string): string {
  const f = new Intl.DateTimeFormat(intlLocale(), { day: 'numeric', month: 'short', year: 'numeric' })
  return `${f.format(new Date(from + 'T00:00:00'))} → ${f.format(new Date(to + 'T00:00:00'))}`
}

/** "Mon 18:00–20:00 · Wed 18:00–20:00" */
export function scheduleSummary(slots: Slot[]): string {
  return slots.map((s) => `${weekdayName(s.dayOfWeek, 'short')} ${s.startsAt}–${s.endsAt}`).join(' · ')
}
